import {last} from 'ramda'

import legacyParseRoleText from 'utils/legacyParseRoleText'
import {Value} from '../../ui'

const roleFields = [
  'name',
  'purpose',
  'domain',
  'accountability',
]

const replaceScalar = (field, {prevValue, isDeleted, isNew}, nextValue) => (
  nextValue
    ? ({[field]: new Value(prevValue, last(nextValue), {isDeleted, isNew})})
    : ({})
)

function mergeArray(field, array, nextArray) {
  if (!nextArray)
    return {}

  const update = nextArray.map(
    (string) => new Value('', string, {isNew: true}),
  )

  return {
    [field]: array.concat(update),
  }
}

function mergeFields(props, newProps, {rewriteArrays} = {}) {
  const {
    domains,
    accountabilities,
    name: nameValue,
    purpose: purposeValue,
  } = props

  const {
    name: nextName,
    purpose: nextPurpose,
    domain: nextDomains,
    accountability: nextAccountabilities,
  } = newProps

  return {
    ...replaceScalar('name', nameValue, nextName),
    ...replaceScalar('purpose', purposeValue, nextPurpose),
    ...mergeArray('domains', (rewriteArrays ? [] : domains), nextDomains),
    ...mergeArray('accountabilities', (rewriteArrays ? [] : accountabilities), nextAccountabilities),
  }
}

export function mergeRoleText(roleText, props) {
  return mergeFields(props, legacyParseRoleText(roleText, roleFields), {rewriteArrays: false})
}

export function mergeRoleTemplate(templateFields, props) {
  return mergeFields(props, {
    name: [templateFields.name],
    purpose: [templateFields.purpose || ''],
    domain: (templateFields.domains || []).filter(Boolean),
    accountability: (templateFields.accountabilities || []).filter(Boolean),
  }, {rewriteArrays: true})
}

export function clearRoleFields(props) {
  return mergeFields(props, {
    name: [''],
    purpose: [''],
    domain: [],
    accountability: [],
  }, {rewriteArrays: true})
}

export function areFieldsEmpty(props) {
  return !props.name.nextValue
      && !props.purpose.nextValue
      && !props.domains?.length
      && !props.accountabilities?.length
}
